import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from '@material-ui/core';
import React, { FC, memo, useCallback } from 'react';
import { viewTexts } from '../../../constants/view-texts';

const vt = viewTexts.dialogs.deleteDialogTemplate;

interface Props {
  title: string;
  messages: readonly string[];
  open: boolean;
  onClose: (yn: 'yes' | 'no') => void;
}

export const ConfirmDeleteDialogTemplate: FC<Props> = memo(
  ({ title, messages, open, onClose }: Readonly<Props>) => {
    const cancelClicked = useCallback(() => {
      onClose('no');
    }, [onClose]);

    const okClicked = useCallback(() => {
      onClose('yes');
    }, [onClose]);

    const onCloseDefault = cancelClicked;

    return (
      <Dialog onClose={onCloseDefault} open={open}>
        <DialogTitle>
          {title}
          {vt.confirmMessagePrefix}
        </DialogTitle>
        <DialogContent>
          {messages.map((msg, idx) => (
            <Typography key={idx}>{msg}</Typography>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelClicked} color='primary'>
            {vt.cancel}
          </Button>
          <Button onClick={okClicked} color='secondary'>
            {vt.ok}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

ConfirmDeleteDialogTemplate.displayName = 'ConfirmDeleteDialogTemplate';
